module.exports = __webpack_public_path__ + "img/ats-integrations.0699d97d.svg";